import React from 'react'

const Feed = (props) => {
    const { id, caption, media_type, media_url,permalink} = props.feed
    let post;

    switch (media_type) {
        case "VIDEO":
            post = (
                <a style={{height:"100%",width:"100%"}}  target="_blank" href={permalink}>
                <video
                    width='100%'
                    height='auto'
                    src={media_url}
                    type="video/mp4"
                    controls playsinline>
                </video>
                </a>
            )
            break;
        case "CAROUSEL_ALBUM":
            post = (
                <a style={{height:"100%",width:"100%"}}  target="_blank" href={permalink}>
                <img
                    width='100%'
                    height='auto'
                    id={id}
                    src={media_url}
                    href="https://www.example.com"
                    alt={caption}
                />
                </a>
            );
            break;
        default:
            post = (
                <a style={{height:"100%",width:"100%"}}  target="_blank" href={permalink}>
                <img
                    width='100%'
                    height='auto'
                    id={id}
                    src={media_url}
                    href="https://www.example.com"
                    alt={caption}
                />
                </a>
            );
    }

    return (
        <React.Fragment>
            {post}
        </React.Fragment>
    );
}

export default Feed;